<template>
  <v-bottom-sheet v-model="sheet" style="z-index: 999">
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
        class="d-flex justify-space-between align-center"
      >
        <v-btn class="caption px-1" text depressed>
          <iconSport :idSport="$route.params.sport" class="flex-grow-0" />
          <span class="px-1">›</span>
          <template v-if="$route.query.flag">
            <img
              class="flag ma-0 flex-grow-0"
              width="26"
              :src="
                `https://dozr8la71aog.cloudfront.net/flags/1x1/${$route.query.flag}.svg`
              "
              :alt="$route.query.category"
            />
            <span class="px-1">›</span>
          </template>
          <template v-else>
            {{ $route.query.category }} <span class="px-1">›</span>
          </template>

          <div
            class="text-truncate"
            :style="$vuetify.breakpoint.smAndDown ? 'width: 30vw' : ''"
          >
            {{ $route.query.tournament }}
          </div>

          <v-icon right>mdi-menu-down</v-icon>
        </v-btn>
      </div>
    </template>
    <v-list light style="border-radius: 16px 16px 0 0">
      <v-subheader class="overline mb-1">
        <iconSport :idSport="$route.params.sport" class="mr-2" />
        <div class="text-truncate">
          {{ $route.query.category }} › {{ $route.query.tournament }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon small @click="sheet = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-subheader>
      <v-divider></v-divider>
      <v-alert dark v-show="errorMsg" class="ma-2" dense color="orange">
        {{ errorMsg }}
      </v-alert>
      <v-list-item-group
        style="overflow-y: auto"
        :style="{
          'max-height': $vuetify.breakpoint.mobile ? '300px' : '600px',
        }"
      >
        <v-list-item
          v-for="event in events"
          :key="event.id"
          @click="routerPush(event.id, event.description)"
        >
          <v-list-item-action class="caption">
            {{ event.scheduled | formatDate }}<br />
            {{ event.scheduled | formatHour }}
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <div class="text-truncate">
                {{ event.description.split(" X ")[0] }}
              </div>
              <div class="text-truncate">
                {{ event.description.split(" X ")[1] }}
              </div>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <div v-if="event.liveodds == 1">
              <v-chip x-small outlined class="my-1 pa-2">live</v-chip>
            </div>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-bottom-sheet>
</template>
<script>
import iconSport from "@/components/icon-sport";
export default {
  name: "bottom-sheet-events",
  components: {
    iconSport,
  },
  data: () => ({
    sheet: false,
    events: [],
    errorMsg: "",
  }),
  mounted() {
    const body = {
      id_tournament: this.$route.params.tournament,
      domain: this.$domain(),
    };
    this.$axios
      .post("/player/table/eventsByTournament", this.$formdata(body))
      .then((response) => {
        this.errorMsg = "";
        this.events = response.data.tournaments[0].events;
      })
      .catch((e) => {
        this.errorMsg = e.response.data.messages.error;
      });
  },
  methods: {
    routerPush: function(eventId, eventDescription) {
      if (eventId == this.$route.params.event) {
        this.sheet = false;
        return;
      }
      if (this.$permissions().bigTable) {
        this.$router.push({
          name: "btEvent",
          params: {
            sport: this.$route.params.sport,
            category: this.$route.params.category,
            tournament: this.$route.params.tournament,
            event: eventId,
          },
          query: {
            sport: this.$route.query.sport,
            category: this.$route.query.category,
            tournament: this.$route.query.tournament,
            event: eventDescription,
            mobile: this.$vuetify.breakpoint.smAndDown,
            liveEvent: false,
            flag: this.$route.query.flag,
          },
          hash: "#scrollTop",
        });
      } else {
        this.$router.push({
          name: "eventsTournament",
          params: {
            sport: this.$route.params.sport,
            category: this.$route.params.category,
            tournament: this.$route.params.tournament,
            event: eventId,
          },
          query: {
            sport: this.$route.query.sport,
            category: this.$route.query.category,
            tournament: this.$route.query.tournament,
            event: eventDescription,
            liveEvent: false,
            mobile: this.$vuetify.breakpoint.mobile,
            flag: this.$route.query.flag,
          },
          hash: "#scrollTop",
        });
      }

      this.sheet = false;
    },
  },
  filters: {
    formatDate: (val) => {
      var lang = document.documentElement.lang;
      if (lang == "pt-br") {
        return new Date(val.replace(" ", "T"))
          .toLocaleDateString()
          .slice(0, -5);
      } else {
        return new Date(val.replace(" ", "T")).toLocaleDateString();
      }
    },
    formatHour: (val) => {
      // Tratamento do Horário quando retornado do websocket ("2020-08-05T19:00:00.000Z")
      // retirar o "Z" do final.
      if (val.lastIndexOf("Z") != -1) {
        return new Date(`${val.slice(0, -5)}-03:00`)
          .toLocaleTimeString()
          .slice(0, -3);
      }
      return new Date(val.replace(" ", "T")).toLocaleTimeString().slice(0, -3);
    },
  },
};
</script>
